/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as StarSvg } from "../../../resources/images/star.svg";

/* Styles */
import styles from "./styles";

const TierRequiredModal = ({
  showTierRequiredModal,
  setShowTierRequiredModal,
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.tierRequiredModal}
      customStyle={classes.tierRequiredModalWrapper}
      showModal={showTierRequiredModal}
      setShowModal={setShowTierRequiredModal}
      modalIcon={<StarSvg />}
      modalTitle={<FormattedMessage id="tierRequiredModal.title" />}
      modalDescription={<FormattedMessage id="tierRequiredModal.description" />}
      modalContent={<Content setShowModal={setShowTierRequiredModal} />}
    />
  );
};

export default TierRequiredModal;
